<template>
  <div class="navbar-settings">
    <h2 class="page-title">导航栏管理</h2>
    <div class="content-container">
      <!-- 操作按钮区 -->
      <div class="action-buttons">
        <button @click="addNewMenuItem" class="btn-add">+ 添加新菜单项</button>
      </div>

      <!-- 导航菜单列表 -->
      <div class="menu-list">
        <div class="menu-header">
          <div class="menu-column">序号</div>
          <div class="menu-column">菜单名称</div>
          <div class="menu-column">路由路径</div>
          <div class="menu-column">是否启用</div>
          <div class="menu-column">操作</div>
        </div>
        <div v-for="(item, index) in menuItems" :key="index" class="menu-item">
          <div class="menu-column">{{ index + 1 }}</div>
          <div class="menu-column">
            <input v-model="item.name" class="form-control" placeholder="菜单名称">
          </div>
          <div class="menu-column">
            <input v-model="item.path" class="form-control" placeholder="路由路径">
          </div>
          <div class="menu-column">
            <input type="checkbox" v-model="item.isActive" class="form-checkbox">
          </div>
          <div class="menu-column action-buttons-item">
            <button @click="saveMenuChanges" class="btn-save">保存</button>
            <button @click="deleteMenuItem(index)" class="btn-delete">删除</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';

// 初始化导航菜单数据
const menuItems = ref([]);
const router = useRouter();

// 从localStorage加载导航菜单数据
const loadMenuItems = () => {
  const savedMenu = localStorage.getItem('navbarMenu');
  if (savedMenu) {
    menuItems.value = JSON.parse(savedMenu);
  } else {
    // 默认数据
    menuItems.value = [
      {
        name: '首页',
        path: '/',
        isActive: true
      },
      {
        name: '产品中心',
        path: '/products',
        isActive: true
      },
      {
        name: '解决方案',
        path: '/solution',
        isActive: true
      },
      {
        name: '技术支持',
        path: '/tech-support',
        isActive: true
      },
      {
        name: '联系我们',
        path: '/contact',
        isActive: true
      }
    ];
    saveMenuItems();
  }
};

// 保存导航菜单数据到localStorage
const saveMenuItems = () => {
  localStorage.setItem('navbarMenu', JSON.stringify(menuItems.value));
};

// 监听数据变化自动保存
watch(menuItems, () => {
  saveMenuItems();
}, { deep: true });

// 添加新菜单项
const addNewMenuItem = () => {
  menuItems.value.push({
    name: '新菜单项',
    path: '/new-path',
    isActive: true
  });
};

// 保存菜单修改
const saveMenuChanges = () => {
  saveMenuItems();
  alert('导航菜单已保存');
};

// 删除菜单项
const deleteMenuItem = (index) => {
  if (menuItems.value.length > 1) {
    menuItems.value.splice(index, 1);
  } else {
    alert('至少保留一个菜单项');
  }
};

// 页面加载时初始化
onMounted(() => {
  // 检查登录状态
  const userStr = localStorage.getItem('adminUser');
  if (!userStr) {
    router.push('/admin/login');
    return;
  }
  loadMenuItems();
});
</script>

<style scoped lang="scss">
.navbar-settings {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.action-buttons {
  margin-bottom: 20px;
  text-align: right;
}

.btn-add {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.menu-list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.menu-header {
  display: flex;
  background-color: #f5f5f5;
  font-weight: bold;
  padding: 12px 15px;
}

.menu-item {
  display: flex;
  border-top: 1px solid #e0e0e0;
  padding: 12px 15px;
  align-items: center;
}

.menu-column {
  flex: 1;
  padding: 0 10px;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
}

.form-checkbox {
  width: 16px;
  height: 16px;
}

.action-buttons-item {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-save {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-delete {
  background-color: #f56c6c;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
</style>